import React from "react";
import { Picker } from "@design-system/Picker/Picker.lib";

interface Props<TValue extends string> {
    value: TValue;
    options: readonly TValue[];
    allValue: TValue;
    labels: Record<TValue, string>;
    prefix: string;
    onChange: (value: TValue) => void;
}

export const SchedulesReportEnumSelect = <TValue extends string>({
    value,
    options,
    allValue,
    labels,
    prefix,
    onChange,
}: Props<TValue>) => (
    <Picker.Select
        items={options.map((option) => ({
            value: option,
            label: labels[option],
        }))}
        value={value}
        onValueChange={(next) => {
            if (next) {
                onChange(next);
            }
        }}
        renderValue={() =>
            value === allValue ? prefix : `${prefix}: ${labels[value]}`
        }
    />
);
